// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"9fad2c68","411":"2cad63dc","455":"ba58360e","512":"8b98506b","570":"8e21dfb3","648":"dd979aec","652":"fd0c77bf","659":"f219d9c1","706":"1b04a72c","709":"c62ca121","766":"68c8e2a3","954":"459b4d2c","977":"240b4497"}[chunkId] + ".chunk.js";
};